<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input
              id="filter-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Qidiruv...')"
              class="modern-search"
            >
          </div>

          <!-- Fayl yuklash -->
          <button
            v-if="rule.open==true"
            class="tool-btn"
            v-b-modal.modal-upload
            type="button"
          >
            <b-icon icon="file-earmark-arrow-up"></b-icon> {{ $t("Файл") }}
          </button>

          <!-- Qo'shish -->
          <button
            v-if="rule.open==true"
            class="add-btn"
            @click="Href('/kirim/create')"
          >
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
          </button>

          <!-- Yangilash -->
          <button class="refresh-btn" @click="Data()" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 90px">{{ $t('ФАКТ №') }}</th>
                <th style="width: 140px">{{ $t('ВАҚТ') }}</th>
                <th>{{ $t('ЕТКАЗУВЧИ') }}</th>
                <th>{{ $t('СКЛАД') }}</th>
                <th style="width: 90px; text-align: right;">{{ $t('СОНИ') }}</th>
                <th style="width: 120px; text-align: right;">{{ $t('СУММА') }}</th>
                <th style="width: 130px; text-align: right;">{{ $t('КИРИМ') }} сумма</th>
                <th style="width: 120px;">{{ $t('ТЎЛОВ ТУРИ') }}</th>
                <th style="width: 130px;">{{ $t('ФОЙДАЛАНУВЧИ') }}</th>
                <th style="width: 160px; text-align: center;">{{ $t('АМАЛЛАР') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in filteredRows"
                :key="item.id"
                @dblclick="Update(item, idx)"
              >
                <td>
                  <span class="id-badge">{{ item.number }}</span>
                </td>
                <td>{{ $formatDate(item.created_at) }}</td>
                <td class="font-bold">
                  <span v-if="item.kontragent != null">{{ item.kontragent.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <span v-if="item.sklad != null">{{ item.sklad.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td style="text-align: right;">{{ item.count_all | numFormat }}</td>
                <td style="text-align: right;">{{ item.summa | numFormat }}</td>
                <td style="text-align: right;">{{ item.prixod_summa | numFormat }}</td>
                <td>
                  <span v-if="item.pay_type != null">{{ item.pay_type.name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <span v-if="item.user != null">{{ item.user.first_name }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <div class="actions">
                    <button class="icon-btn nx" @click="openNarxnoma(item)" title="Narxnoma (PDF)">
                      <b-icon icon="file-earmark-pdf"></b-icon>
                    </button>
                    <button class="icon-btn lot" @click="$router.push('/xisobot/partiya?prixod_id=' + item.id)" title="Partiya hisoboti">
                      <b-icon icon="bar-chart-line"></b-icon>
                    </button>
                    <template v-if="rule.change==true">
                      <button class="icon-btn edit" @click="$router.push('/kirim/update/' + item.id)">
                        <b-icon icon="pencil-square"></b-icon>
                      </button>
                      <button class="icon-btn del" @click="Trash(item.id)">
                        <b-icon icon="trash"></b-icon>
                      </button>
                    </template>
                  </div>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="filteredRows.length === 0">
                <td colspan="10" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ totalRows }}</b> ta yozuv
          </div>
          <div v-if="totalRows > $store.state.countindex">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="$store.state.countindex"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- UPLOAD MODAL -->
    <b-modal id="modal-upload" title="" size="xl" hide-footer @shown="Shovedform">
      <form>
        <div class="row">
        <div class="col-md-6">
          <label for="">Склад</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="md-input" :options="skladlist" v-model="datas.sklad_id"
          :reduce="name => name.id" label="name">
          <template #search="{attributes, events}">
            <input class="vs__search" v-bind="attributes" v-on="events" />
            <button type="button" class="modallist" v-b-modal.modal-skladlist>
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <button type="button" @click="unit.name = search" v-b-modal.modal-unit class="pluss">
                +
              </button>
              <b>insert</b>
            </template>
            <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">{{$t('Етказувчи')}}</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="form-control-sm required md-input" :options="kontragentlist"
          v-model="datas.kontragent_id" :reduce="name => name.id" label="name">
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">{{$t('Тўлов тури')}}</label>
        </div>
        <div class="col-md-6">
          <v-select :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
          v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
        </v-select>
        </div>
        <div class="col-md-6">
          <label for="">Курс</label>
        </div>
        <div class="col-md-6">
          <input type="number" v-model="datas.dollar_rate" class="form-control">
        </div>
      </div>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
        <button type="button" class="btn btn-primary" @click="Yuklash()">
          {{ $t("Сақлаш") }}
        </button>
      </form>
    </b-modal>

    <!-- Narxnoma: valyuta + optom/chakana tanlash -->
    <b-modal ref="nxModal" title="Narxnoma (PDF)" hide-footer centered>
      <p class="text-muted mb-1" style="font-size:13px">Valyuta:</p>
      <div class="d-flex mb-3" style="gap:8px">
        <button type="button" :class="['btn flex-grow-1', nxCurrency==='dollar' ? 'btn-dark' : 'btn-outline-dark']" @click="nxCurrency='dollar'">Dollar $</button>
        <button type="button" :class="['btn flex-grow-1', nxCurrency==='som' ? 'btn-dark' : 'btn-outline-dark']" @click="nxCurrency='som'">So'm</button>
      </div>
      <p class="text-muted mb-1" style="font-size:13px">Qaysi narx bo'yicha chiqarilsin?</p>
      <div class="d-flex" style="gap:8px">
        <button type="button" class="btn btn-primary flex-grow-1" @click="generateNarxnoma('optom')" :disabled="nxLoading">Optom narx</button>
        <button type="button" class="btn btn-success flex-grow-1" @click="generateNarxnoma('chakana')" :disabled="nxLoading">Chakana narx</button>
      </div>
      <p v-if="nxLoading" class="text-center text-muted mt-2 mb-0" style="font-size:12px">Tayyorlanmoqda...</p>
    </b-modal>
  </div>
</template>

<script>
import Top from "../Layout/Top.vue";
import { print } from "../../components/mixins/print.js";
import filterFunction from "../../utils/filterFunction";
import { printNarxnoma } from "../Xisobot/Xisobot/narxnomaPdf";
export default {
  mixins: [print],
  components: {Top},
  data() {
    return {
      datas: {
          file: "",
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          pay_type_id:1,
          dollar_rate:1,
          kontragent_id:0,
        },
        paytypelist:[],
        skladlist: [],
        kontragentlist: [],
        // Narxnoma (PDF) modali
        nxItem: null,
        nxLoading: false,
        nxCurrency: 'dollar',
      items: [],
      errors: "",
      fields: [
        {
          key: "number",
          label: "Факт №",
          sortable: true,
          class: "text-center column1"
        },
        {
          key: "created_at",
          label: this.$t("Вақт"),
          sortable: true,
          formatter: (value, key, item) => {
            return this.$formatDate(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column3"
        },
        {
          key: "kontragent",
          label: this.$t("Етказувчи"),
          sortable: true,
          class: "text-center"
        },
        { key: "sklad", label: "Cклад", sortable: true, class: "text-center" },
        {
          key: "count_all",
          label: this.$t("Сони"),
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "summa",
          label: "Сумма",
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "prixod_summa",
          label: this.$t("Кирим")+' cумма',
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "pay_type",
          label: this.$t("Тўлов тури"),
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "user_id",
          label: this.$t("Фойдаланувчи"),
          sortable: true,
          class: "text-center column2",
          formatter: (value, key, item) => {
            if(item.user!=null){
              return item.user.first_name;
            }else{
              return "";
            }
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "", class: "column2 text-center" }
      ],
      file: "",
      totalRows: 1,
      send:false,
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    filteredRows() {
      let rows = this.items;
      if (this.filter && this.filter.length > 1) {
        const q = this.filter.toLowerCase();
        rows = rows.filter(row =>
          (row.number && String(row.number).toLowerCase().includes(q)) ||
          (row.kontragent && row.kontragent.name && row.kontragent.name.toLowerCase().includes(q)) ||
          (row.sklad && row.sklad.name && row.sklad.name.toLowerCase().includes(q))
        );
      }
      this.totalRows = rows.length;
      const perPage = this.$store.state.countindex;
      const start = (this.currentPage - 1) * perPage;
      return rows.slice(start, start + perPage);
    }
  },
  mounted() {
    this.Data();
    this.$store.state.selected_index = null;
    // this.Interval();
  },
  created:function(){
    this.$root.$refs.index = this;
   let self=this;
      axios.get("api/v1/pay-type").then(function(response) {
        self.paytypelist = response.data;
      });
      axios.get("api/v1/sklads").then(function(response) {
        self.skladlist = response.data;
      });
      axios.get("api/v1/kontragent").then(function(response) {
        self.kontragentlist = response.data;
      });
      axios.get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.datas.dollar_rate=response.data.rate;
        });
  },
  methods: {
    // Narxnoma — prixodni tanlab, optom/chakana so'rab, PDF chiqarish
    openNarxnoma(item) {
      this.nxItem = item;
      this.$refs.nxModal.show();
    },
    async generateNarxnoma(mode) {
      if (!this.nxItem) return;
      this.nxLoading = true;
      try {
        const res = await axios.post('api/v1/report/narxnoma-by-prixod/', { prixod_id: this.nxItem.id });
        const items = (res.data && res.data.items) || [];
        if (!items.length) { alert('Bu kirimda mahsulot topilmadi'); return; }
        this.$refs.nxModal.hide();
        printNarxnoma(items, mode, this.nxCurrency);
      } catch (e) {
        alert('Xatolik: ' + ((e.response && e.response.data && e.response.data.message) || 'Narxnoma chiqmadi'));
      } finally {
        this.nxLoading = false;
      }
    },
    handleFileUpload() {
        this.file = this.$refs.file.files;
        this.datas.file = URL.createObjectURL(this.$refs.file.files[0]);
      },
    Yuklash() {
        let self = this;
        if(self.send==false){
          self.send=true;
          let formData = new FormData();
        let file = self.file[0];
        formData.append("file_name", file);
        formData.append("sklad_id", this.datas.sklad_id);
        formData.append("pay_type_id", this.datas.pay_type_id);
        formData.append("dollar_rate", this.datas.dollar_rate);
        formData.append("kontragent_id", this.datas.kontragent_id);
        formData.append("user_id", localStorage.getItem("user_id"));
        axios({
          method: "post",
          url: "api/v1/upload/prixod",
          data: formData
        }).then(function (response) {
          self.datas.file="";
          self.file="";
          self.send=false;
          self.$bvModal.hide("modal-upload");
          self.Data();
        }).catch(function(error){
          self.send=false;
        });
        }else{
          console.log('not');
        }
      },
    filterFunction,
    Update(record, index) {
      if(this.rule.open==true){
      this.$router.push({ path: '/kirim/update/' + record.id});
      }
    },
    Shovedform() {
        this.$refs.file.focus();
      },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/prixod"
      }).then(function(response) {
        self.items = response.data;
        self.totalRows = self.items.length;
      });
    },
    Interval() {
      window.setInterval(() => {
        this.Data();
      }, 60000);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Trash(id) {
      let self=this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
            method: "delete",
            url: "api/v1/prixod/id/" + id
          }).then(function(response) {
            self.Data();
          }).catch(function(e) {
            self.$store.state.errors = (e.response && e.response.data && e.response.data.message) || self.$t("Xatolik");
          });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        .catch(function() {});
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

.tool-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.tool-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.refresh-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 18px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.custom-table tbody tr:hover {
  background: #faf8ff;
  cursor: pointer;
}

/* ID BADGE */
.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

.text-muted {
  color: #94a3b8;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.nx {
  background: #fef2f2;
  color: #e11d2a;
}
.nx:hover {
  background: #e11d2a;
  color: white;
  transform: scale(1.1);
}

.lot {
  background: #ecfdf5;
  color: #059669;
}
.lot:hover {
  background: #059669;
  color: white;
  transform: scale(1.1);
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .modern-search {
    width: 100%;
  }
}
</style>
